var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.baseUrl + _vm.url + _vm.id + '?access_token=' + _vm.$cookie.get('TmsToken'),"target":"_Blank"}},[_vm._v(" "+_vm._s(_vm.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }